module.exports = __webpack_public_path__ + "img/mobile-logo.938bb0d.png";